import React, { createContext, useContext, useEffect, useState } from "react";
import { http } from "../lib/api";

const AuthContext = createContext(null);

const STORAGE_KEY = "voyager_token";

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);      // null while unknown
  const [ready, setReady] = useState(false);   // true when we've resolved initial state

  useEffect(() => {
    // Attach interceptor once
    const token = localStorage.getItem(STORAGE_KEY);
    if (token) {
      http.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    // 401 handler
    const id = http.interceptors.response.use(
      (r) => r,
      (err) => {
        if (err?.response?.status === 401) {
          localStorage.removeItem(STORAGE_KEY);
          delete http.defaults.headers.common["Authorization"];
          setUser(null);
          if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/p/")) {
            window.location.href = "/login";
          }
        }
        return Promise.reject(err);
      }
    );
    if (token) {
      http.get("/auth/me")
        .then((r) => setUser(r.data))
        .catch(() => setUser(null))
        .finally(() => setReady(true));
    } else {
      setReady(true);
    }
    return () => http.interceptors.response.eject(id);
  }, []);

  const login = async (email, password) => {
    const r = await http.post("/auth/login", { email, password });
    localStorage.setItem(STORAGE_KEY, r.data.token);
    http.defaults.headers.common["Authorization"] = `Bearer ${r.data.token}`;
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem(STORAGE_KEY);
    delete http.defaults.headers.common["Authorization"];
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
